import { Outlet } from "react-router-dom";
import LandingNav from "../components/LandingNav";
import SkipLink from "../components/SkipLink";

export default function LandingLayout() {
  return (
    <>
      <SkipLink />
      <LandingNav />
      <main id="main-content" tabIndex={-1}>
        <Outlet />
      </main>
    </>
  );
}
